import OrderTracker from "@iewccouk/Components/OrderTracker";
import { colorPalette } from "@iewccouk/Utilities/variables";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { FC } from "react";
import { connect } from "react-redux";

const enum fields {
    heading = "heading",
    description = "description",
    statusSequence = "statusSequence",
    allProductsInLastStepLabel = "allProductsInLastStepLabel",
}

export interface StatusSequenceModel {
    fields: {
        labelSingular: string;
        labelPlural: string;
    };
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.heading]: string;
        [fields.description]: string;
        [fields.statusSequence]: StatusSequenceModel[];
        [fields.allProductsInLastStepLabel]: string;
    };
}

const mapStateToProps = (state: any) => ({
    tracker: state.pages.orderStatus?.order?.orderTracker,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const OrderStatusOrderTracker: FC<Props> = ({ tracker, fields }) => {
    return <OrderTracker tracker={tracker} fields={fields} />
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderStatusOrderTracker),
    definition: {
        allowedContexts: ["OrderStatusPage"],
        displayName: "Order tracker",
        group: "Order Status",
        fieldDefinitions: [
            {
                name: fields.heading,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Order Status",
                isRequired: false,
            },
            {
                name: fields.allProductsInLastStepLabel,
                displayName: "All products in last step label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "All lines shipped",
                isRequired: true,
            },
            {
                name: fields.description,
                displayName: "Description",
                editorTemplate: "RichTextField",
                defaultValue: "Your order may be shipped in multiple deliveries. Check statuses below.",
                fieldType: "Translatable",
                isRequired: false,
            },
            {
                name: fields.statusSequence,
                editorTemplate: "ListField",
                displayName: "Status Sequence",
                getDisplay: (item: HasFields) => item.fields.labelPlural,
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "labelSingular",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        displayName: "Singular Label",
                        isRequired: true,
                    },
                    {
                        name: "labelPlural",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        displayName: "Plural Label",
                        isRequired: true,
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
